import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './projects.css';

const Projects = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        fetch('/upload/data/projects.json')
            .then((res) => res.json())
            .then((data) => setProjects(data.projects ?? data))
            .catch((err) => console.error('Failed to load projects:', err));
    }, []);

    return (
        <section id="projects" className="projects-section-3d">
            <div className="projects-container-3d">
                <div className="projects-header-3d">
                    <h2 className="projects-title-3d">Featured Projects</h2>
                    <p className="projects-subtitle-3d">A showcase of my recent work and technical implementations</p>
                </div>

                <div className="projects-grid-3d">
                    {projects.map((project, index) => (
                        <div
                            key={project.id}
                            className={`project-card-3d project-${project.id}-3d ${project.featured ? 'featured' : ''}`}
                            style={{ animationDelay: `${index * 0.15}s` }}
                        >
                            <div className="project-card-content-3d">

                                <div className="project-header-3d">
                                    <div className="project-icon-3d">{project.icon}</div>
                                    {project.featured && (
                                        <div className="project-featured-badge-3d">
                                            <span>⭐ Featured</span>
                                        </div>
                                    )}
                                </div>

                                <h3 className="project-title-3d">{project.title}</h3>
                                <p className="project-description-3d">{project.description}</p>

                                <div className="project-tags-3d">
                                    {project.tags && project.tags.map((tag, tagIndex) => (
                                        <span key={tagIndex} className="project-tag-3d">{tag}</span>
                                    ))}
                                </div>

                                <div className="project-links-3d">
                                    <Link
                                        to={`/project/${project.id}`}
                                        className="project-link-3d"
                                    >
                                        <span>View Details</span>
                                        <span className="link-arrow-3d">→</span>
                                    </Link>

                                    {project.githubLink && (
                                        <a
                                            href={project.githubLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="project-link-3d github-link-3d"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <span>🔗 GitHub</span>
                                        </a>
                                    )}

                                    {project.liveLink && (
                                        <a
                                            href={project.liveLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="project-link-3d demo-link-3d"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <span>🚀 Live Demo</span>
                                        </a>
                                    )}
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Projects;